'use client'

import React, {useState} from 'react'
import clsx from 'clsx' // Import clsx
import ViewIntersection from '@app/components/analytics/view-intersection/view-intersection'
import {ReactNode} from 'react'
import s from './style.module.scss' // Import your styles

type Props = {
  children: ReactNode
  index: number
  delay?: number
  initialCss?: string
  animateCss?: string
}

const AnimateOnVisibleWrapper = ({
  children,
  index,
  initialCss = s.animateWrapper,
  animateCss = s.fadeIn,
  delay = 30,
}: Props) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <ViewIntersection
      onVisible={() => setIsVisible(true)}
      className={clsx(initialCss, {[animateCss]: isVisible})}
      style={{transitionDelay: `${index * delay}ms`}}
    >
      {children}
    </ViewIntersection>
  )
}

export default AnimateOnVisibleWrapper
